module.exports = __webpack_public_path__ + "static/cssBar@2x-b2fabb5f25594877edef299700965e59.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/handoff/cssBar@2x.png
// module id = 2599
// module chunks = 168707334958949